export const clickOutsideOfElementListener = (element: HTMLElement, callback: () => void) => {
    const handleClickOutside = eventWindowClicked => {
        const path = eventWindowClicked.composedPath && eventWindowClicked.composedPath();

        path.every(el => el !== element) && callback();
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
        window.removeEventListener('click', handleClickOutside);
    };
};
